import { SKIP_SUBSCRIPTION_REQUEST, SKIP_SUBSCRIPTION_SUCCESS, SKIP_SUBSCRIPTION_ERROR, } from '../types';
import { useHelper } from '../helpers';
export const skipSubscriptionRequest = (id) => ({
    type: SKIP_SUBSCRIPTION_REQUEST,
    payload: id,
});
export const skipSubscriptionSuccess = ({ data, products, }) => ({
    type: SKIP_SUBSCRIPTION_SUCCESS,
    payload: {
        data,
        products,
    },
});
export const skipSubscriptionError = (id, error) => ({
    type: SKIP_SUBSCRIPTION_ERROR,
    payload: { error, id },
    error: true,
});
export const skipSubscription = (subscriptionId) => (options) => async (dispatch, getState, { chord }) => {
    const { withAuth } = useHelper(dispatch, getState);
    dispatch(skipSubscriptionRequest(subscriptionId));
    try {
        const { user } = getState();
        const userId = user.data.id;
        const response = await withAuth(chord.oms.skipSubscription)(userId, subscriptionId);
        dispatch(skipSubscriptionSuccess({
            data: response,
            products: options?.products,
        }));
        return response;
    }
    catch (error) {
        dispatch(skipSubscriptionError(subscriptionId, error));
        throw error;
    }
};
